import moment from 'moment';

export const defaultSelectOption = {
  id: 0,
  value: '',
  sysName: '',
};

export const convertSysNameToSelectOption = (sysName, referenceBook) => {
  return (
    referenceBook.find((o) => {
      return o.sysName === sysName;
    }) || defaultSelectOption
  );
};

export const convertOptionToSysName = (option) => {
  return option && option.sysName;
};

export const convertDate = (dateString) => {
  if (dateString === '-0001-11-30' || !dateString) {
    return '';
  }
  if (dateString.includes('.')) {
    return dateString;
  }

  const converted = moment(dateString, 'YYYY-MM-DD').format('DD.MM.YYYY');

  return converted === 'Invalid date' ? '' : converted;
};
